import { num } from 'starknet'
import { getProvider } from '../services/amm'
import { Network, StarknetChainId } from '../services/token.service'

export type NetworkName = 'mainnet-alpha' | 'goerli-alpha' | 'devnet' | 'integration'

export type SNSEntry = {
    name: string
    address: string
    iconUrl?: string
}

export const SNS_DOMAIN_SUFFIX = 'stark'
const basicAlphabet = 'abcdefghijklmnopqrstuvwxyz0123456789-'
const basicSizePlusOne = num.toBigInt(basicAlphabet.length + 1)
const bigAlphabet = '这来'
const bigAlphabetSize = num.toBigInt(bigAlphabet.length)
const bigAlphabetSizePlusOne = num.toBigInt(bigAlphabet.length + 1)

export const getSNSFromAddress = async (network: Network, address: string, getIcon: boolean = true): Promise<SNSEntry | undefined> => {
    if (network === 'sepolia-alpha') return undefined
    try {
        const contractAddress =
            network === 'mainnet-alpha' ? '0x6ac597f8116f886fa1c97a23fa4e08299975ecaf6b598873ca6792b9bbfb678' : '0x003bab268e932d2cecd1946f100ae67ce3dff9fd234119ea2f6da57d16d29fce'
        if (contractAddress) {
            const provider = await getProvider(network)
            const res = await provider.callContract({
                contractAddress: contractAddress,
                entrypoint: 'address_to_domain',
                calldata: [address, []]
            })

            if (res.result?.length && Number(res.result[0]) !== 0) {
                const nameFelts = res.result.slice(1)
                const name = _useDecoded(nameFelts.map((x) => BigInt(num.toHexString(x))))
                // nameFelts.map(x => number.toBN(number.toHexString(x)))

                if (name) {
                    // save immediately to cache
                    // saveToSNSCache(network, { name, address });

                    let iconUrl
                    if (getIcon && !/\.braavos\.stark$/.test(name)) {
                        const res1 = await provider.callContract({
                            contractAddress: contractAddress,
                            entrypoint: 'domain_to_id',
                            calldata: res.result.map((x) => num.toBigInt(num.toHexString(x)).toString(10))
                        })
                        if (res1.result?.length) {
                            const token_id = num.toBigInt(num.toHexString(res1.result[0]))
                            iconUrl = `https://www.starknet.id/api/identicons/${token_id}`
                        }
                    }

                    const entry = { name, address, iconUrl }
                    // save to cache with iconUrl
                    // saveToSNSCache(network, entry);

                    return entry
                }
            }
        }
    } catch (e: any) {
        throw new Error('Failed to get SNS from addess', e.message)
    }

    return undefined
}

export function _useDecoded(encoded: bigint[]): string | undefined {
    let decoded = ''

    encoded.forEach((subdomain) => {
        while (subdomain !== BigInt(0)) {
            const code = Number(subdomain % basicSizePlusOne)
            subdomain = subdomain / basicSizePlusOne
            if (code === basicAlphabet.length) {
                const nextSubdomain = subdomain / bigAlphabetSizePlusOne
                if (nextSubdomain === BigInt(0)) {
                    const code2 = Number(subdomain % bigAlphabetSizePlusOne)
                    subdomain = nextSubdomain
                    if (code2 === 0) decoded += basicAlphabet[0]
                    else decoded += bigAlphabet[code2 - 1]
                } else {
                    const code2 = Number(subdomain % bigAlphabetSize)
                    decoded += bigAlphabet[code2]
                    subdomain = subdomain / bigAlphabetSize
                }
            } else decoded += basicAlphabet[code]
        }

        const [str, k] = extractStars(decoded)
        if (k)
            decoded =
                str +
                (k % 2 === 0
                    ? bigAlphabet[bigAlphabet.length - 1].repeat(k / 2 - 1) + bigAlphabet[0] + basicAlphabet[1]
                    : bigAlphabet[bigAlphabet.length - 1].repeat((k - 1) / 2 + 1))
        if (!decoded.endsWith('.')) {
            decoded += '.'
        }
    })
    return decoded !== '' ? decoded.concat(SNS_DOMAIN_SUFFIX) : undefined
}

function extractStars(str: string): [string, number] {
    let k = 0
    while (str.endsWith(bigAlphabet[bigAlphabet.length - 1])) {
        str = str.substring(0, str.length - 1)
        k += 1
    }
    return [str, k]
}

// export function getRPCUrl(network: Network) {
//     if (network === 'goerli-alpha') {
//         return 'https://braavos-goerli-juno-rpc.nethermind.io/rpc/v0_6'
//     }
//     if (network === 'mainnet-alpha') {
//         return 'https://braavos-mainnet-juno-rpc.nethermind.io/rpc/v0_6'
//     }
//     if (network === 'sepolia-alpha') {
//         // return 'https://starknet-sepolia.public.blastapi.io/'
//         // return 'https://starknet-sepolia.public.blastapi.io'
//         // return 'https://limited-rpc.nethermind.io/sepolia-juno'
//         return 'https://braavos-sepolia-juno-rpc.nethermind.io/rpc/v0_6'
//     }
//     return ''
// }

export function getRPCUrl(network: Network) {
    if (network === 'goerli-alpha') {
        //return 'https://braavos-goerli-juno-rpc.nethermind.io/rpc/v0_5'
        return 'https://starknet-testnet.blastapi.io/e0e4734b-1a20-4184-83a5-5aa1d45cc47a/rpc/v0_6'
    }
    if (network === 'mainnet-alpha') {
        return 'https://braavos-mainnet-juno-client-myswap.nethermind.io/rpc/v0_6'
        //return 'https://braavos-mainnet-juno-rpc-0.nethermind.io/rpc/v0_6'
        //return 'https://braavos-mainnet-juno-rpc.nethermind.io/rpc/v0_5'
        //return 'https://starknet-mainnet.core.chainstack.com/cd61f06c931c7c4f01175316eaff31fd/rpc/v0.5'
        //return 'https://starknet-mainnet.blastapi.io/e0e4734b-1a20-4184-83a5-5aa1d45cc47a/rpc/v0_6'
    }
    if (network === 'sepolia-alpha') {
        // return 'https://starknet-sepolia.public.blastapi.io/'
        // return 'https://starknet-sepolia.public.blastapi.io'
        // return 'https://limited-rpc.nethermind.io/sepolia-juno'
        return 'https://braavos-sepolia-juno-rpc-0.nethermind.io/rpc/v0_6'
    }
    return ''
}

export const getStarknetChainIdFromNetwork = (network: Network): StarknetChainId | undefined => {
    switch (network) {
        case 'mainnet-alpha':
            return StarknetChainId.MAINNET
        case 'goerli-alpha':
        // case "devnet": // same as goerli-alpha (according to @yoavg)
        //     return StarknetChainId.TESTNET;
        // eslint-disable-next-line no-fallthrough
        default:
            return undefined
    }
}

//TODO: NOT USED ANYMORE, RIGHT?
export function getTokenCoingeckoName(tokenSymbol: string): string {
    const tokenSymbolToGeckoSymbol = {
        DAI: 'dai',
        ETH: 'ethereum',
        USDC: 'usd-coin',
        WBTC: 'bitcoin',
        USDT: 'tether',
        wstETH: 'wrapped-steth',
        WSTETH: 'wrapped-steth',
        LORDS: 'lords',
        STRK: 'stark'
    } as Record<string, string>
    return tokenSymbolToGeckoSymbol[tokenSymbol] || ''
}

// export const tokensBraavos = ['eth', 'dai', 'usdc', 'usdt', 'wsteth', 'wbtc', 'lords']

export function getTokenBraavosName(tokenSymbol: string): string {
    const tokenSymbolToGeckoSymbol = {
        DAI: 'dai',
        ETH: 'eth',
        USDC: 'usdc',
        WBTC: 'wbtc',
        USDT: 'usdt',
        wstETH: 'wsteth',
        WSTETH: 'wsteth',
        LORDS: 'lords',
        LUSD: 'lusd',
        rETH: 'reth',
        STRK: 'strk',
        UNI: 'uni'
    } as Record<string, string>
    return tokenSymbolToGeckoSymbol[tokenSymbol] || ''
}

export function apiUrl(network: string) {
    if (network.includes('mainnet')) {
        return 'https://clapi.myswap.xyz'
    }
    if (network.includes('goerli')) {
        return 'https://542xi6g52a.execute-api.us-east-1.amazonaws.com/staging'
    }
    if (network.includes('sepolia')) {
        return 'https://972vd4rnm3.execute-api.us-east-1.amazonaws.com/sepolia'
    }

    return 'https://542xi6g52a.execute-api.us-east-1.amazonaws.com/staging'
}

export function staticDataBucket(network: string) {
    let bucket = 'myswap-cl-charts-staging'
    if (network.includes('mainnet')) {
        bucket = 'myswap-cl-charts'
    }
    if (network.includes('sepolia')) {
        bucket = 'myswap-cl-charts-sepolia'
    }
    return `https://${bucket}.s3.amazonaws.com`
}
